import { createContext, useContext, useEffect, useState } from "react";

const CartContext = createContext(null);
const KEY = "turco_cart_v1";

export const CartProvider = ({ children }) => {
  const [items, setItems] = useState(() => {
    try { return JSON.parse(localStorage.getItem(KEY) || "[]"); } catch { return []; }
  });
  useEffect(() => { localStorage.setItem(KEY, JSON.stringify(items)); }, [items]);

  const add = (product, qty = 1) => {
    setItems(prev => {
      const idx = prev.findIndex(i => i.stock_id === product.id);
      if (idx >= 0) {
        const next = [...prev];
        next[idx] = { ...next[idx], quantity: next[idx].quantity + qty };
        return next;
      }
      return [...prev, {
        stock_id: product.id, name: product.name, brand: product.brand || "",
        code: product.code || product.sku, unit_price: product.unit_price,
        vat_rate: product.vat_rate, image: product.image || (product.images?.[0] || ""),
        quantity: qty, max_quantity: product.quantity,
      }];
    });
  };

  const update = (stock_id, quantity) => {
    setItems(prev => prev.map(i => i.stock_id === stock_id ? { ...i, quantity } : i).filter(i => i.quantity > 0));
  };
  const remove = (stock_id) => setItems(prev => prev.filter(i => i.stock_id !== stock_id));
  const clear = () => setItems([]);

  const totals = items.reduce((acc, i) => {
    const net = i.quantity * i.unit_price;
    const vat = net * i.vat_rate / 100;
    return { net: acc.net + net, vat: acc.vat + vat, gross: acc.gross + net + vat };
  }, { net: 0, vat: 0, gross: 0 });
  const count = items.reduce((s, i) => s + i.quantity, 0);

  return <CartContext.Provider value={{ items, add, update, remove, clear, totals, count }}>{children}</CartContext.Provider>;
};
export const useCart = () => useContext(CartContext);
